import React, { useEffect, useState } from "react";
import { initMercadoPago, Wallet } from "@mercadopago/sdk-react";
import { Toast, ToastContainer } from "react-bootstrap";
import styles from "./MercadoPago.module.css";

const MercadoPago = ({ data, orderData }) => {
  console.log("Datos recibidos en MercadoPago:", { data, orderData });

  const [error, setError] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Inicializar Mercado Pago
  useEffect(() => {
    try {
      console.log("Inicializando Mercado Pago...");
      initMercadoPago("APP_USR-c96dc4b0-31f3-42b2-b0b0-9ce75f066d1b", {
        locale: "es-AR",
      });
      console.log("Mercado Pago inicializado correctamente.");
    } catch (err) {
      console.error("Error al inicializar Mercado Pago:", err);
      setError("Error al cargar el formulario de pago. Inténtalo de nuevo.");
      setShowToast(true);
      setIsLoading(false);
    }
  }, []);

  // Validar props iniciales
  useEffect(() => {
    console.log("Validando datos iniciales...");
    if (!data?.preferenceId) {
      console.error("Falta preferenceId en data:", data);
      setError("Falta el ID de la preferencia de pago.");
      setShowToast(true);
      setIsLoading(false);
      return;
    }

    if (!orderData) {
      console.error("Falta orderData:", orderData);
      setError("Faltan datos del pedido.");
      setShowToast(true);
      setIsLoading(false);
      return;
    }

    const { unit_price, title, billingInfo, shippingInfo, kitsCompra } =
      orderData;
    if (!unit_price || !title || !billingInfo || !shippingInfo || !kitsCompra) {
      console.error("Datos incompletos en orderData:", orderData);
      setError("Faltan datos necesarios para procesar el pago.");
      setShowToast(true);
      setIsLoading(false);
      return;
    }

    if (Number(unit_price) < 1) {
      console.error("Monto inválido:", unit_price);
      setError("El monto es demasiado bajo para procesar el pago.");
      setShowToast(true);
      setIsLoading(false);
      return;
    }

    if (!billingInfo.name || !billingInfo.surname || !billingInfo.phone) {
      console.error("Datos de facturación incompletos:", billingInfo);
      setError("Faltan datos de contacto (nombre, apellido o teléfono).");
      setShowToast(true);
      setIsLoading(false);
      return;
    }

    if (
      !shippingInfo.email ||
      !shippingInfo.postalCode ||
      !shippingInfo.street
    ) {
      console.error("Datos de envío incompletos:", shippingInfo);
      setError("Faltan datos de envío (email, código postal o dirección).");
      setShowToast(true);
      setIsLoading(false);
      return;
    }

    console.log("Validación de datos iniciales completada correctamente.");
    setIsLoading(false);
  }, [data, orderData]);

  // Validar datos iniciales
  if (!data || !orderData) {
    console.error("Datos no disponibles:", { data, orderData });
    return (
      <div className={styles.mercadoPagoContainer}>
        <ToastContainer
          className={`position-fixed p-3 ${styles.customtoastcontainer}`}
          style={{ top: "35%", right: "35%" }}
        >
          <Toast
            className={styles.customtoastcontainer2}
            onClose={() => {
              console.log("Cerrando Toast de error inicial...");
              setShowToast(false);
            }}
            show={true}
            delay={5000}
            autohide
          >
            <Toast.Header>
              <strong className="me-auto">Error en el pago</strong>
            </Toast.Header>
            <Toast.Body>Datos de pago no disponibles.</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    );
  }

  return (
    <div className={styles.mercadoPagoContainer}>
      <ToastContainer
        className={`position-fixed p-3 ${styles.customtoastcontainer}`}
        style={{ top: "35%", right: "35%" }}
      >
        {showToast && (
          <Toast
            className={styles.customtoastcontainer2}
            onClose={() => {
              console.log("Cerrando Toast de error...");
              setShowToast(false);
            }}
            show={showToast}
            delay={5000}
            autohide
          >
            <Toast.Header>
              <strong className="me-auto">Error en el pago</strong>
            </Toast.Header>
            <Toast.Body>{error}</Toast.Body>
          </Toast>
        )}
      </ToastContainer>

      {isLoading && <p>Cargando formulario de pago...</p>}

      {!isLoading && data.preferenceId && !error && (
        <div id="wallet_container" className={styles.walletContainer}>
          {console.log(
            "Renderizando Wallet con preferenceId:",
            data.preferenceId
          )}
          <Wallet
            initialization={{ preferenceId: data.preferenceId }}
            onError={(err) => {
              console.error("Error en el componente Wallet:", err);
              setError(
                "Error al cargar el formulario de pago. Inténtalo de nuevo."
              );
              setShowToast(true);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default MercadoPago;
